import React from "react";
import LookupAdmin, { ColorSwatch, ActiveChip } from "../../components/LookupAdmin";

const config = {
  title: "Categorias Financeiras",
  subtitle: "Classificam contas a pagar e a receber. Aparecem como opção ao lançar e nos relatórios financeiros.",
  endpoint: "/finance/categories",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 5 },
    {
      name: "kind",
      label: "Tipo",
      type: "select",
      required: true,
      span: 3,
      defaultValue: "expense",
      options: [
        { value: "income", label: "Receita" },
        { value: "expense", label: "Despesa" }
      ]
    },
    { name: "color", label: "Cor", type: "color", span: 2 },
    { name: "active", label: "Ativa", type: "boolean", defaultValue: true }
  ],
  columns: [
    {
      key: "name",
      label: "Nome",
      render: (c) => (
        <span>
          <ColorSwatch color={c.color} />
          {c.name}
        </span>
      )
    },
    { key: "kind", label: "Tipo", render: (c) => (c.kind === "income" ? "Receita" : "Despesa") },
    { key: "active", label: "Status", render: (c) => <ActiveChip active={c.active} /> }
  ]
};

const FinanceCategories = () => <LookupAdmin config={config} />;
export default FinanceCategories;
